/* Divine Order (Cleric 1, D&D 2024 / SRD 5.2.1), saved at `classState.cleric.divineOrder` as { id }.
 * CommonJS like spellPreparation.js: the spell limits and skill bonuses that read it are synchronous on both runtimes.
 */
const DIVINE_ORDERS = Object.freeze([
  Object.freeze({ id: 'protector', name: 'Protector', summary: 'Trained for battle, you gain proficiency with Martial weapons and training with Heavy armor.' }),
  Object.freeze({ id: 'thaumaturge', name: 'Thaumaturge', summary: 'You know one extra Cleric cantrip, and you add your Wisdom modifier (minimum +1) to Intelligence (Arcana or Religion) checks.' }),
]);
const THAUMATURGE_SKILLS = Object.freeze(['arcana', 'religion']);

const getDivineOrder = (character) => DIVINE_ORDERS.find((order) => order.id === character?.classState?.cleric?.divineOrder?.id) || null;
/** Cantrips the order adds to the Cleric's limit. */
const divineOrderCantrips = (character) => (getDivineOrder(character)?.id === 'thaumaturge' ? 1 : 0);
/** What a Thaumaturge adds to this skill's check; 0 for anyone else and any other skill. */
const thaumaturgeSkillBonus = (character, skill, wisdomModifier) => (getDivineOrder(character)?.id === 'thaumaturge' && THAUMATURGE_SKILLS.includes(skill)
  ? Math.max(1, Math.floor(Number(wisdomModifier) || 0)) : 0);

module.exports = { DIVINE_ORDERS, THAUMATURGE_SKILLS, getDivineOrder, divineOrderCantrips, thaumaturgeSkillBonus };
